import { useContext, useEffect, useState } from "react"
import { FiEye, FiPlus } from "react-icons/fi"
import { Form, Formik } from "formik"
import { toast } from "react-toastify"
import { useLocation } from 'react-router-dom'

import { Button, Select, Textarea, Textbox } from "../../../../components/Form"
import Modal from "../../../../components/Modal"
import masks from "../../../../util/masks"
import formUtils from '../../../../util/form'
import { api, authHeaders } from "../../../../services/api"
import Spinner from "../../../../components/Spinner"
import Table from "../../../../components/Table"
import { EtapaDetalhe } from "./EtapaDetalhes"
import { GlobalContext } from "../../../../contexts/GlobalContext"

export function EtapasProjeto({ projeto, loadProjeto, etapaAbertaMemoState, etapaPessoaAbertaMemoState }) {
	const { user, checkException } = useContext(GlobalContext)

	const { state } = useLocation()

	const [etapaAbertaMemo, setEtapaAbertaMemo] = etapaAbertaMemoState
	const [etapaPessoaAbertaMemo, setEtapaPessoaAbertaMemo] = etapaPessoaAbertaMemoState

	const [etapaAberta, setEtapaAberta] = useState(null)
	const [etapaPessoaAberta, setEtapaPessoaAberta] = useState(null)
	const [isCadastroOpen, setIsCadastroOpen] = useState(false)

	async function handleCadastrar(values) {
		try {
			values = formUtils.extractFormValues(values)

			await api.post(`projeto_etapa/${projeto.id}`, values, authHeaders())

			toast.success('Etapa cadastrada com sucesso.')

			setIsCadastroOpen(false)

			loadProjeto()
		} catch (e) {
			checkException(e)
		}
	}

	useEffect(() => {
		if (projeto && etapaAbertaMemo) {
			setEtapaAberta(etapaAbertaMemo)
		}
	}, [projeto, etapaAbertaMemo])

	useEffect(() => {
		if (projeto && etapaPessoaAbertaMemo) {
			setEtapaPessoaAberta(etapaPessoaAbertaMemo)
		}
	}, [projeto, etapaPessoaAbertaMemo])

	useEffect(() => {
		if (state?.etapa) {
			setEtapaAberta(projeto.etapas.find(e => e.id === +state.etapa))
		}
	}, [state])

	if (!projeto) {
		return <Spinner />
	}

	const eAutor = projeto.pessoas.some(p => p.id === user.pessoa.id && p.condicao.toLowerCase() === 'autor')
	const trls = projeto.trls

	const podeCadastrarEtapa = !!trls && !!trls.length

	if (!podeCadastrarEtapa) {
		return (
			<div className="flex justify-center items-center h-32 gap-4">
				<p>Para cadastrar etapas do projeto, você deve iniciar o TRL primeiramente.</p>
			</div>
		)
	}

	return (
		<div className="flex flex-col gap-4">
			{eAutor && (
				<Button onClick={() => { setIsCadastroOpen(true) }} className="transparent self-end w-fit">
					Cadastrar etapa
					<FiPlus size={16} />
				</Button>
			)}

			<Table
				headers={[
					{ name: 'titulo', value: 'Etapa' },
					{ name: 'trl', value: 'Nível TRL', centered: true },
					{ name: 'percentual_conclusao', value: 'Percentual conclusão do MRL', centered: true },
					{ name: 'equipe_quantidade_pessoas', value: 'Equipe', centered: true },
					{ name: 'inicio_formatado', value: 'Início previsto', centered: true, style: { width: '8rem' } },
					{ name: 'fim_formatado', value: 'Fim previsto', centered: true, style: { width: '8rem' } }
				]}
				data={projeto.etapas}
				actions={[
					{
						action: item => {
							setEtapaAberta(item)

							setEtapaAbertaMemo(item)
						},
						name: 'Exibir',
						icon: FiEye,
						iconSize: 16,
						checkDisabled: item => {
							return !eAutor && !item.projeto_etapa_pessoas.some(item => item.projeto_pessoa.pessoa.id === user.pessoa.id)
						},
						disabledTooltip: 'Não acessível'
					}
				]}
				legends={[
					{
						color: '#d1fae5',
						text: 'Previsto'
					},
					{
						color: '#ffcdd2',
						text: 'Em atraso'
					},
					{
						color: '#fff59d',
						text: 'Próximo ao fim'
					}
				]}
			/>

			<Modal
				isOpen={isCadastroOpen}
				title={projeto?.nome || ''}
				handleClose={() => {
					setIsCadastroOpen(false)
				}}
			>
				{projeto && (
					<p className="text-lg mx-3 font-normal">MRL - Cadastro de etapa</p>
				)}

				<Formik
					initialValues={{
						title: '',
						objetivo: '',
						inicio: '',
						fim: '',
						trl: null
					}}
					onSubmit={handleCadastrar}
				>
					{({ isSubmitting, setFieldValue }) => (
						<Form className="flex flex-col lg:grid lg:grid-cols-2">
							<Textbox
								name="titulo"
								label="Título"
							/>

							<Select
								name="trl"
								label="Nivel TRL"
								onChange={(selected, meta) => {
									setFieldValue(meta.name, selected)
								}}
								options={trls.map(({ trl }) => ({
									label: `TRL nível ${trl.nivel} - ${trl.descricao}`,
									value: trl.id
								}))}
							/>

							<Textarea
								name="objetivo"
								label="Objetivos"
								style={{
									marginBottom: 0
								}}
							/>

							<div className="flex flex-col xl:flex-row">
								<Textbox
									name="inicio"
									label="Início previsto"
									mask={masks.date}
									containerClass=""
								/>

								<Textbox
									name="fim"
									label="Fim previsto"
									mask={masks.date}
								/>
							</div>

							<Button type="submit" className="white self-end lg:col-start-2 w-fit justify-self-end" loading={isSubmitting}>
								Cadastrar etapa
							</Button>
						</Form>
					)}
				</Formik>
			</Modal>

			<Modal
				isOpen={!!etapaAberta}
				handleClose={() => {
					setEtapaAberta(null)

					setEtapaAbertaMemo(null)
				}}
				title={`Etapa: ${etapaAberta ? etapaAberta.titulo : ''}`}
			>
				<EtapaDetalhe
					etapaAberta={etapaAberta}
					etapaPessoaAbertaId={etapaPessoaAberta}
					projeto={projeto}
					onChangePessoasLista={loadProjeto}
					onChangeToggleTarefa={loadProjeto}
					onSubmitRelatorio={loadProjeto}
					onChangeDocumentos={loadProjeto}
					onCreateTarefa={pessoaEtapaId => {
						loadProjeto()

						setEtapaPessoaAbertaMemo(pessoaEtapaId)
					}}
				/>
			</Modal>
		</div>
	)
}